import { API, METHODS, ROLES } from '../../constants';
import { fetchData } from '../common/apiCalling';

export const impersonateUser = ({ userId, role = ROLES.USER }) => {
    let url = `${API.IMPERSONATE}`;

    return fetchData({ body: { id: userId, role }, method: METHODS.POST, url });
};
